export default "__VITE_ASSET__Dik9Ef$M__"